export var Features;
(function (Features) {
    Features["posts"] = "posts";
    Features["chat"] = "chat";
    Features["profile"] = "profile";
    Features["tasks"] = "tasks";
    Features["calendar"] = "calendar";
    Features["tickets"] = "tickets";
    Features["swipeMeet"] = "swipeMeet";
    Features["greenlisting"] = "greenlisting";
    Features["mail"] = "mail";
    Features["meet"] = "meet";
    Features["home"] = "home";
    Features["organization"] = "organization";
    Features["stuff"] = "stuff";
    Features["support"] = "support";
    Features["workspaceConfig"] = "workspaceConfig";
    Features["forms"] = "forms";
    Features["feedback"] = "feedback";
    Features["studio"] = "studio";
    Features["wardrobe"] = "wardrobe";
    Features["contacts"] = "contacts";
})(Features || (Features = {}));
